/**
 * Safe address formatter - handles string, object, or null
 * Matches address shape: { street, city, parish, gps_lat, gps_lng }
 */
export const formatAddress = (a) => {
  if (!a) return '';
  if (typeof a === 'string') return a;
  const parts = [a.street, a.city, a.parish].filter(Boolean);
  return parts.join(', ');
};

/**
 * Get destination string - prefers GPS coordinates if available
 */
export const getStopDestination = (s) => {
  const a = s?.dropoff_address || s?.destination_address || s?.pickup_address;
  if (!a) return '';
  if (a.gps_lat && a.gps_lng) return `${a.gps_lat},${a.gps_lng}`;
  return formatAddress(a);
};

export const safeText = (v) => {
  if (v == null) return '';
  if (typeof v === 'object') return formatAddress(v);
  return String(v);
};

export default formatAddress;
